export default "__VITE_ASSET__BHXTsUX2__"